/**
 * Deterministic PII normalization mirroring the mobile Meta Advanced Matching contract
 * (iOS `OnDeviceConversionHasher`), so hashes computed on web match mobile/Meta expectations.
 */

export function normalizeEmail (email: string | null | undefined): string {
  return (email ?? '').trim().toLowerCase()
}

export function normalizePhone (phone: string | null | undefined): string {
  return (phone ?? '').replace(/[^0-9]/g, '')
}
